/**
 * displayName — derive a short, conversational display label from the
 * BE-stored profile ``name`` field.
 *
 * Single source of truth used by every chat surface that wants to feel
 * personalised: the greeting in ``ChatEmptyState`` ("Buongiorno
 * Leonardo."), the composer placeholder ("Su cosa lavoriamo,
 * Leonardo?"), and any future "concierge"-style copy.
 *
 * Falls back to the empty string when the BE profile is missing or
 * blank — the caller branches on that to render a generic copy
 * without an awkward trailing comma ("Su cosa lavoriamo?" vs
 * "Su cosa lavoriamo, ?").
 *
 * NEVER returns the email address even as a fallback — exposing the
 * email here gives the surface a lock-screen / unauthenticated feel
 * that we explicitly want to avoid (Jun 2026 cold-start UX audit).
 */

export function firstNameOf(fullName: string | null | undefined): string {
  if (!fullName) return "";
  const trimmed = fullName.trim();
  if (trimmed.length === 0) return "";
  return trimmed.split(/\s+/)[0] ?? trimmed;
}
